import { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/apiClient';

/**
 * Загружает список пользователей, лайкнувших пост.
 *
 * @param {number|string} globalPostId - глобальный ID поста
 * @returns {{ users: Array, loading: boolean, error: string|null }}
 */
export function useUsersLikes(globalPostId) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!globalPostId) return;

        let isMounted = true;

        const fetchUsers = async () => {
            try {
                setLoading(true);
                setError(null);

                const accessToken = localStorage.getItem('accessToken');

                const res = await apiFetch(`/api/post/likes?id=${globalPostId}`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });

                if (!res.ok) throw new Error('Ошибка при загрузке лайков');

                const data = await res.json();

                if (isMounted) setUsers(data?.users ?? []);
            } catch (err) {
                if (isMounted) setError('Не удалось загрузить лайки');
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchUsers();

        return () => {
            isMounted = false;
        };
    }, [globalPostId]);

    return { users, loading, error };
}
